import { useMemo } from 'react'
import useTrans from '../../../hooks/useTrans'
import { Button } from '../../atoms'
import NewModal from '../../molecules/NewModal/NewModal'
import Link from 'next/link'

const NoFornitoreModal = ({ tecnica, maxQuantita, isVisible, setVisible, onClose }) => {
  const t = useTrans()

  return (
    <NewModal
      className="no-fornitore-modal"
      visible={isVisible}
      alert={true}
      title={t('Non è possibile ordinare la quantità scelta')}
      text={
        <>
          <div
            className="no-fornitore-modal__content"
            dangerouslySetInnerHTML={{
              __html: tecnica
                ? t(
                    'Per la tecnica selezionata: <strong>{0}</strong> il massimo personalizzabile dal sito è: <strong>{1} pz</strong>',
                    [tecnica.nome, maxQuantita || 9999]
                  )
                : t('Il massimo personalizzabile dal sito è: <strong>{0} pz</strong>', [
                    maxQuantita || 9999,
                  ]),
            }}
          />
          <p>
            {t('Modifica la quantità inserita oppure per quantità superiori')}{' '}
            <Link href="/contatti">
              <a>{t('Contattaci')}</a>
            </Link>
          </p>
        </>
      }
      onClose={() => {
        !!setVisible && setVisible(false)
        !!onClose && onClose()
      }}
      actions={[
        <Button
          label={t('Conferma')}
          variant="primary"
          size="medium"
          onClick={() => {
            !!setVisible && setVisible(false)
            !!onClose && onClose()
          }}
          key="no-fornitore-modal__confirm"
        />,
      ]}
    ></NewModal>
  )
}

export default NoFornitoreModal
